<div class="contents">
    <app-back-button></app-back-button>
    <div class="page-header">
        <div class="left-area">
            <span class="title">Grupos</span>
            <span class="sub-title">Adicione, edite e Visualize os grupos</span>
        </div>
        <div class="indicator" *ngIf="totalRecords">
            <div class="indicator">
                <div class="icon">
                    <img src="icons/users-01.svg" alt="Country Icon" />
                </div>
                <div class="text-bg">
                    <span>{{totalRecords}} Grupos</span>
                </div>
            </div>
        </div>
    </div>

    <app-lista-perfil (totalRecordsChange)="onTotalRecordsChange($event)"></app-lista-perfil>

</div>